import { NAVBAR_SIDE_ICON, NAVBAR_COLOR } from '@/store/types';
import * as enums from '@/types/enums';
import Vue from 'vue';
import { store } from '../index';
import moment from 'moment';
import {router} from '@/router'
import {ChangeEventInterface} from "@/types/interfaces";

const vueAppData = process.env.VUE_APP_DATA;
const moduleDecorators = require(`../../decorators/${vueAppData}Decorators/${vueAppData}ModuleDecorators`).default;

export const displayModule = {
  namespaced: true,
  state: {
    navBar: {
      title: '',
      icon: NAVBAR_SIDE_ICON.menu,
      color: '',
      path: null,
    },
    scrollingOptions: {
      container: 'body',
      duration: 1500,
      easing: 'ease',
      offset: 0,
      force: true,
      cancelable: true,
      onStart: false,
      onDone: false,
      onCancel: false,
      x: false,
      y: true,
    },
    colors: {
      [enums.FEED_TYPE.sectionApproved]: NAVBAR_COLOR.blue,
      [enums.FEED_TYPE.sectionEdited]: NAVBAR_COLOR.blue,
      [enums.SECTION_STATUS.approved]: NAVBAR_COLOR.blue,
      [enums.FEED_TYPE.edited]: NAVBAR_COLOR.blue,
      pros: NAVBAR_COLOR.blue,
      true: NAVBAR_COLOR.blue,
      [enums.SECTION_STATUS.inTheVote]: NAVBAR_COLOR.purple,
      [enums.FEED_TYPE.toEditSectionSuggestion]: NAVBAR_COLOR.purple,
      undefined: '#000000de',
      comment: NAVBAR_COLOR.purple,
      add: NAVBAR_COLOR.purple,
      addComment: NAVBAR_COLOR.purple,
      [enums.SECTION_STATUS.toEdit]: NAVBAR_COLOR.yellow,
      [enums.SECTION_STATUS.toEditInTheVote]: NAVBAR_COLOR.yellow,
      [enums.FEED_TYPE.deleted]: NAVBAR_COLOR.yellow,
      cons: NAVBAR_COLOR.red,
      false: NAVBAR_COLOR.red,
      [enums.FEED_TYPE.rejected]: NAVBAR_COLOR.red,
      [enums.SECTION_STATUS.toDelete]: NAVBAR_COLOR.red,
    },
    snackbar: {
      snackbar: false,
      y: 'top',
      x: null,
      mode: 'multi-line',
      timeout: 10000000,
    },
    eventsCounter: 0
  },
  getters: {
    navBar: (state) => state.navBar,
    scrollingOptions: (state) => state.scrollingOptions,
    getColor: (state) => (status) => state.colors[status],
    getBorderTopColor: (state) => (status) => state.colors[status],
    snackbar: (state) => state.snackbar,
    /**
     * formatting from timestamp to date
     * @param {number} timestamp
     *
     */
    dateFormatted: (state) => (timestamp) => {
      if(typeof timestamp === 'string'){ // for version mockdata in usersList page
        return Object.assign({}, { date: moment(timestamp).format('DD.MM.YYYY'), time: moment(timestamp).format('HH:mm') });
      }
      if (timestamp && 'seconds' in timestamp) {
        timestamp = moment.unix(timestamp.seconds);
      }
      return Object.assign({}, { date: moment(timestamp).format('DD.MM.YYYY'), time: moment(timestamp).format('HH:mm') });
    },
    showDeleteButton: (state, getters, rootState, rootGetters) => (ownerId) => {
      const userUid = rootGetters['usersModule/userUid'];
      return ownerId === userUid
    },
  },
  mutations: {
    setSnackbar: (state) => {
      Vue.set(state.snackbar, 'snackbar', true);
    },
    closeSnackbar: (state) => {
      Vue.set(state.snackbar, 'snackbar', false);
    },
    showSnackbar: (state, id) => {
      if (router.currentRoute.query[enums.SECTION_BY.sectionById] === id || router.currentRoute.name === "vote" || router.currentRoute.name === "section") {
        Vue.set(state.snackbar, 'snackbar', true);
      }
    },
    /**
     * setting the Mav Bar properties
     * @param context
     * @param context
     * @param {object} payload object with keys: title / sideIcon / navBarColor/ action
     */
    setNavBar: (context, payload) => {
      context.navBar.icon = undefined;
      Object.keys(payload).forEach((key) => {
        const navBar = context.navBar;
        const payloadElement = payload[key];
        Object.assign((navBar[key] = payloadElement));
      });
    },
    setMainToolbarColor: (state) => {
      const color = store.getters['documentsModule/mainThemeColor'];
      if (color) {
        state.colors[enums.SECTION_STATUS.inTheVote] = color;
        state.colors[enums.FEED_TYPE.toEditSectionSuggestion] = color;
        state.colors.comment = color;
        state.colors.add = color;
        state.colors.addComment = color;
      }
    },
  },
  actions: {},
  moduleName: '',
  statePropName: '',
  sync: {},
  serverChange: {},
  fetch: {
    docLimit: 0,
  },
};
moduleDecorators['displayModuleDecorator'](displayModule);
